export const resolverBridgeQueryKeys = {
    submitRequestFlow: ['submit-request-flow'] as const,
    createJob: ['resolver-bridge-create-job'] as const,
    jobStatus: (jobId: string | undefined) => ['resolver-bridge-job-status', jobId] as const,
    jobResults: (jobId: string | undefined) => ['resolver-bridge-job-results', jobId] as const,
    updateJob: ['resolver-bridge-update-job'] as const,
    getAlternatives: (jobId: string | undefined, altToken: string | undefined) =>
        ['resolver-bridge-get-alternatives', jobId, altToken] as const,
};
